import { Img } from '@/components/blocks/MaterialImage';
import { useMediaQuery, useTheme } from '@mui/material';

export const DpBannerCheckout = ({
	image,
}: {
	image:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const getImage = typeof image === 'string' ? image : isMobile ? image?.mobile : image?.desktop;

	return <Img src={getImage} sx={{ maxWidth: isMobile ? '300px' : '350px' }} />;
};
